import { useTranslation } from 'react-i18next'

import { AgentVerificationDetailsListItem } from '@percent/admin-dashboard/app/agentVerification/agentVerificationDetails/components/agentVerificationDetailsListItem/AgentVerificationDetailsListItem'
import { PercentButton } from '@percent/admin-dashboard/common/components'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { AcknowledgeModal, Box, ConfirmationModal, Modal, Typography } from '@percent/lemonade'
import styles from './ActivityCheckSuccessModal.module.scss'
import { ActivityCheckSuccessModalProps } from './ActivityCheckSuccessModal.types'
import { useMutation } from '@percent/utility'

export function ActivityCheckSuccessModal({
  isOpened,
  setIsOpened,
  primaryDescription,
  subDescription,
  updatedCode,
  orgName,
  orgId,
  refresh,
  setModalState,
  modalState
}: ActivityCheckSuccessModalProps) {
  const { t } = useTranslation()
  const { activityCheckService } = useServices()

  const [{ isPending, errorMessage }, { apiFunc: aproveFunc }] = useMutation(
    activityCheckService.postActivityCheck,
    () => {
      setModalState('success')
      refresh()
    },
    () => {
      setModalState('error')
    }
  )

  const handleApprove = () => {
    aproveFunc({ id: orgId ?? undefined, activity: updatedCode.subDescription.substring(0, 3) })
  }

  const handleClose = () => {
    setIsOpened(false)
    setModalState('confirm')
  }

  return (
    <Modal open={isOpened} onClose={handleClose}>
      {modalState === 'confirm' && (
        <ConfirmationModal
          loading={isPending}
          handleClose={handleClose}
          primaryButtonText={t('dialog.changeCode')}
          handleSubmit={handleApprove}
          secondaryButtonText={t('button.cancel')}
          title={t('dialog.changeCode')}
        >
          <Box className={styles.dialogBody} data-testid="activity-check-accept-modal">
            <Typography variant="large" className={styles.bodyText}>
              {t('dialog.aboutToChange')} <span>{orgName}</span> {t('dialog.code')}
            </Typography>
            <ul className={styles.detailsList}>
              <AgentVerificationDetailsListItem title={t('dialog.from')} />
              <AgentVerificationDetailsListItem title={t('typography.primary')}>
                <PercentButton title={primaryDescription} disabled />
              </AgentVerificationDetailsListItem>
              <AgentVerificationDetailsListItem title={t('typography.sub')}>
                <PercentButton title={subDescription} disabled />
              </AgentVerificationDetailsListItem>
              <AgentVerificationDetailsListItem title={t('dialog.to')} />
              <AgentVerificationDetailsListItem title={t('typography.primary')}>
                <PercentButton title={updatedCode.primaryDescription} disabled />
              </AgentVerificationDetailsListItem>
              <AgentVerificationDetailsListItem title={t('typography.sub')}>
                <PercentButton title={updatedCode.subDescription} disabled />
              </AgentVerificationDetailsListItem>
            </ul>
            <Typography variant="large" className={styles.bodyText}>
              {t('dialog.willBeChanged')}
            </Typography>
          </Box>
        </ConfirmationModal>
      )}
      {modalState === 'success' && (
        <AcknowledgeModal
          result="positive"
          title={t('dialog.activityCodeChanged')}
          handleClose={handleClose}
          buttonText={t('button.close')}
        />
      )}
      {modalState === 'error' && (
        <AcknowledgeModal
          result="negative"
          title={t('dialog.somethingWentWrong')}
          handleClose={handleClose}
          buttonText={t('button.close')}
          description={errorMessage}
        />
      )}
    </Modal>
  )
}
